import type { ICountLabelsQuery } from '@protocols/use-cases';
import { CloudFunctions } from '@telespot/sdk';

export class CountLabelsCloudQuery implements ICountLabelsQuery {
  public async execute(searchTerm?: string): Promise<number> {
    return CloudFunctions.CountLabels({ searchTerm });
  }
}
